import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { loadFont } from "@remotion/google-fonts/JetBrainsMono";
import { COLOR, perFormatScale } from "../../../brand/theme";

const { fontFamily } = loadFont("normal", { weights: ["400", "700"] });

export type LowerThirdProps = {
  name: string;
  role: string;
};

export const LowerThird: React.FC<LowerThirdProps> = ({ name, role }) => {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();
  const k = perFormatScale({ w: width, h: height });
  const enter = spring({ frame, fps, config: { damping: 200 } });
  const slide = interpolate(enter, [0, 1], [-60 * k, 0]);
  const op = interpolate(frame, [0, 16], [0, 1], { extrapolateRight: "clamp" });

  return (
    // transparent demo over dark; in production composite over video.
    <AbsoluteFill style={{ backgroundColor: "#0d0d12", fontFamily }}>
      <div
        style={{
          position: "absolute", left: 80 * k, bottom: 110 * k,
          transform: `translateX(${slide}px)`, opacity: op,
          display: "flex", alignItems: "stretch", gap: 24 * k,
        }}
      >
        <div style={{ width: 8 * k, backgroundColor: COLOR.blue, borderRadius: 4 }} />
        <div style={{ background: "rgba(29,28,32,0.72)", padding: `${20 * k}px ${34 * k}px`, borderRadius: 6 }}>
          <div style={{ color: COLOR.white, fontSize: 44 * k, fontWeight: 700, letterSpacing: 1 }}>{name}</div>
          <div style={{ color: COLOR.blue300, fontSize: 28 * k, fontWeight: 400, letterSpacing: 2 * k, marginTop: 6 * k }}>{role}</div>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
